import Loadable from 'react-loadable';

const PropertyAssessmentLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "propertyAssessment" */ './index'),
  loading: () => null,
});

export default PropertyAssessmentLoadable;
